module.exports = __webpack_public_path__ + "img/sd-card.ab0577ff.svg";